import { useContext } from 'react';

import { CandidateAdminContext } from 'contexts';

export const useCandidateAdminContext = () => useContext(CandidateAdminContext);
